<template>
    <div class="more">
        <img src="@/assets/images/icons/more.svg" :width="size">
    </div>
</template>
<script>
export default {
    name: 'More',
    props: {
        size: {
            type: Number,
            require: false
        }
    }
}
</script>
<style lang="stylus">
.more
    display flex
    align-items center
    cursor pointer
</style>